import { Z_INDEX } from 'src/constants/zIndex';

/**
 * Tooltip portal props for anything rendered *inside* the Assistant panel.
 *
 * MUI portals a Tooltip to `document.body` at `theme.zIndex.tooltip` (1500). The panel
 * is `position: fixed` at `Z_INDEX.MAX` (99999), so a tooltip opened from a button in
 * the panel renders **behind** it — the text is laid out, focusable and announced, but
 * invisible. That is not a styling nicety; it makes the two icon-only buttons in the
 * composer (attach, screenshot) undiscoverable.
 *
 * The floating launcher already solved this the same way; this is the shared constant so
 * every tooltip in the panel uses one rule instead of four copies that can drift.
 */
export const PANEL_TOOLTIP_SLOT_PROPS = {
  popper: { style: { zIndex: Z_INDEX.MAX + 1 } },
} as const;

export default PANEL_TOOLTIP_SLOT_PROPS;
